import { ONE_DAY, ONE_HOUR } from '@zet/utils/cacheTime'

export const getTimeRemaining = (expiryTime: number) => {
  const currentTime = new Date().getTime()
  const timeRemaining = expiryTime - currentTime
  const days =
    timeRemaining > ONE_DAY
      ? Math.ceil(timeRemaining / ONE_DAY)
      : Math.floor(timeRemaining / ONE_DAY)
  const hours = Math.floor((timeRemaining % ONE_DAY) / ONE_HOUR)

  if (days < 0 || hours < 0) {
    return false
  }

  return days < 1
    ? `${hours} ${hours > 1 ? 'hours' : 'hour'}`
    : `${days} ${days > 1 ? 'days' : 'day'}`
}
